<script>
  import { onDestroy } from "svelte"
  export let activeItem
  export let fontName
  export let link = ""
  export let contenteditable = true
  let textarea
  let placeholder = "Paste your copied link tag here!"
  const autoGrow = () => {
    textarea.style.height = textarea.scrollHeight + "px"
  }
  let timer = setInterval(autoGrow, 50)
  onDestroy(() => {
    clearTimeout(timer)
  })
</script>

<div class="relative">
  <textarea
    on:paste
    {contenteditable}
    on:click={() => {
      contenteditable = true
    }}
    on:input={autoGrow}
    bind:value={link}
    bind:this={textarea}
    class="custom-font {activeItem} block min-h-[100px] w-full resize-none overflow-hidden rounded-md {contenteditable ? 'border-[#a0a1a580]' : 'border-none'} border bg-transparent px-3 py-2 pb-9 text-justify text-sm text-white outline-none placeholder:text-gray-200 focus:border focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
    {placeholder}
    style="--customFont : '{fontName}'"
  />
</div>

<style lang="postcss">
  .custom-font {
    font-family: var(--customFont) !important;
  }
  .Normal {
    @apply font-thin;
  }
  .Bold {
    @apply font-extrabold;
  }
  .Italic {
    @apply italic;
  }
</style>
